'use client' // Error boundaries must be Client Components
import { ErrorFallback } from 'components/ErrorBoundaryWrapper'

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
    return <ErrorFallback error={error} onResetAction={reset} />
}
